import { Link } from "react-router-dom";
import { useI18n } from "../i18n/LanguageProvider";

export default function Footer() {
  const { lang, t } = useI18n();
  const year = new Date().getFullYear();

  return (
    <footer
      className="bg-[#0F2537] text-slate-200 border-t-4 border-[#C85A32]"
      data-testid="site-footer"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-12 py-14 lg:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-14">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <span className="inline-flex items-center justify-center w-9 h-9 rounded-sm bg-[#C85A32] text-white font-bold text-sm">
                Z
              </span>
              <span className="font-heading text-lg font-semibold tracking-tight text-white">
                {t("footer.about_title")}
              </span>
            </div>
            <p className="text-sm text-slate-300 leading-relaxed">
              {t("footer.about_body")}
            </p>
          </div>

          <div>
            <h3 className="text-xs font-bold tracking-widest uppercase text-slate-400 mb-4">
              {t("footer.sections_title")}
            </h3>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link
                  to={`/${lang}`}
                  className="text-slate-200 hover:text-white"
                  data-testid="footer-link-home"
                >
                  {t("nav.home")}
                </Link>
              </li>
              <li>
                <a
                  href={`/${lang}#sector`}
                  className="text-slate-200 hover:text-white"
                  data-testid="footer-link-sector"
                >
                  {t("nav.sector")}
                </a>
              </li>
              <li>
                <a
                  href={`/${lang}#process`}
                  className="text-slate-200 hover:text-white"
                  data-testid="footer-link-process"
                >
                  {t("nav.process")}
                </a>
              </li>
              <li>
                <a
                  href={`/${lang}#transparency`}
                  className="text-slate-200 hover:text-white"
                  data-testid="footer-link-transparency"
                >
                  {t("nav.transparency")}
                </a>
              </li>
              <li>
                <a
                  href={`/${lang}#newsletter`}
                  className="text-slate-200 hover:text-white"
                  data-testid="footer-link-newsletter"
                >
                  {t("footer.links.newsletter")}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-xs font-bold tracking-widest uppercase text-slate-400 mb-4">
              {t("footer.legal_title")}
            </h3>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link
                  to={`/${lang}/privacy-policy`}
                  className="text-slate-200 hover:text-white"
                  data-testid="footer-link-privacy"
                >
                  {t("footer.links.privacy")}
                </Link>
              </li>
              <li>
                <Link
                  to={`/${lang}/cookie-policy`}
                  className="text-slate-200 hover:text-white"
                  data-testid="footer-link-cookies"
                >
                  {t("footer.links.cookies")}
                </Link>
              </li>
              <li>
                <Link
                  to={`/${lang}/terms`}
                  className="text-slate-200 hover:text-white"
                  data-testid="footer-link-terms"
                >
                  {t("footer.links.terms")}
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-xs font-bold tracking-widest uppercase text-slate-400 mb-4">
              {t("footer.contact_title")}
            </h3>
            <address className="not-italic text-sm space-y-3 text-slate-300">
              <div>
                <div className="text-slate-400 text-xs uppercase tracking-wider mb-1">
                  {t("footer.address_label")}
                </div>
                <div>{t("footer.address_value")}</div>
              </div>
              <div>
                <div className="text-slate-400 text-xs uppercase tracking-wider mb-1">
                  {t("footer.email_label")}
                </div>
                <a
                  href={`mailto:${t("footer.email_value")}`}
                  className="text-white hover:underline"
                  data-testid="footer-email-link"
                >
                  {t("footer.email_value")}
                </a>
              </div>
              <div>
                <div className="text-slate-400 text-xs uppercase tracking-wider mb-1">
                  {t("footer.phone_label")}
                </div>
                <a
                  href={`tel:${t("footer.phone_value").replace(/\s|-/g, "")}`}
                  className="text-white hover:underline"
                  data-testid="footer-phone-link"
                >
                  {t("footer.phone_value")}
                </a>
              </div>
            </address>
          </div>
        </div>

        <div className="mt-14 pt-10 border-t border-[#1a3550] grid grid-cols-1 lg:grid-cols-2 gap-8 text-xs text-slate-400 leading-relaxed">
          <div className="space-y-2">
            <p className="text-slate-200 font-semibold text-sm">
              {t("footer.legal_name")} — {t("footer.cuit")}
            </p>
            <p>{t("footer.igj")}</p>
            <p>{t("footer.cnv")}</p>
            <p>{t("footer.afip")}</p>
            <p>{t("footer.jurisdiction")}</p>
            <p>{t("footer.incorporation")}</p>
          </div>
          <div className="space-y-3">
            <p>{t("footer.disclaimer")}</p>
            <p className="text-slate-300">
              &copy; {year} {t("footer.legal_name")}. {t("footer.rights")}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
